import { PermissionEnum } from './enums/PermissionEnum';

export const UserTypes = {
	Admin: 'SGFT.Admin',
	Sop: 'SGFT.Sop',
	Rh: 'SGFT.Rh',
	Regulatorio: 'SGFT.Regulatorio',
	RhTreinamento: 'SGFT.Training.Rh',
	QsmsTreinamento: 'SGFT.Training.Qsms',
	Director: 'SGFT.Directors',
	User: 'SGFT.User',
	ReadOnly: 'SGFT.ReadOnly',
	OnDutyWorker: 'SGFT.OnDutyWorker',
	Manager: 'SGFT.Manager',
	TurnstileAccess: 'SGFT.TurnstileAccess',
	ViewTurnstile: 'SGFT.ViewTurnstile',
};

export const PermissionMessages = {
	NoPermission: 'Usuário sem permissão',
	OutOfPolicyNoPermission: 'Somente RH pode salvar férias fora da política',
};

// Permissions

const RhPermissions = [
	PermissionEnum.RequirementControlCanSee,
	PermissionEnum.RequirementControlCanEdit,
	PermissionEnum.OrganizationChartCanSee,
	PermissionEnum.OrganizationChartCanEdit,
	PermissionEnum.FixedAllocationsCanSee,
];
const RhTrainingPermissions = [
	PermissionEnum.OrganizationChartCanSee,
	PermissionEnum.TrainingControlCanSee,
	PermissionEnum.TrainingControlCanUpload,
];
const DirectorPermissions = [
	PermissionEnum.RequirementControlCanSee,
	PermissionEnum.OrganizationChartCanSee,
	PermissionEnum.TrainingControlCanSee,
];
const QsmsPermissions = [PermissionEnum.TrainingControlCanSee];
const AdminPermissions = [
	...RhPermissions,
	PermissionEnum.TrainingControlCanSee,
	PermissionEnum.TrainingControlCanUpload,
];

export const UserTypesPermissions: Partial<
	Record<keyof typeof UserTypes, PermissionEnum[]>
> = {
	[UserTypes.Director]: DirectorPermissions,
	[UserTypes.Rh]: RhPermissions,
	[UserTypes.RhTreinamento]: RhTrainingPermissions,
	[UserTypes.Admin]: AdminPermissions,
	[UserTypes.QsmsTreinamento]: QsmsPermissions,
};
